import { VStack } from "@whoosh/design-system/src/components/primitive";

import { MemberHoldCounter } from "./MemberHoldCounter";

type MemberListHeaderProps = {
  capacityOnBooking: number;
};

export const MemberListHeader = ({
  capacityOnBooking,
}: MemberListHeaderProps) => {
  return (
    <VStack>
      <MemberHoldCounter capacityOnBooking={capacityOnBooking} />
    </VStack>
  );
};
